const home: Record<string, string> = {
  // Hero
  'hero.eyebrow': 'Type Approval · Homologation · Regulatory Compliance',
  'hero.title': 'Your trusted partner for global market access',
  'hero.intro': 'Helping manufacturers, testing laboratories, government entities, and third-party organizations complete product certification in over 180 countries — faster, with full traceability, and completely hassle-free.',
  'hero.cta1': 'Start Onboarding',
  'hero.cta2': 'Explore Our Services',
  'stats.0.label': 'Years of expertise',
  'stats.1.label': 'Countries supported',
  'stats.2.label': 'Certificates delivered',
  'stats.3.label': 'First-pass success rate',

  // About
  'about.eyebrow': 'Who we are',
  'about.title': 'About Gaudi Enterprises Global Compliance',
  'about.p1': 'In Brazil, Bracert Certifcacoes is an authorized commercial agent for Bracert Certificate — a <strong>Designated Certification Body (OCD)</strong> authorized by ANATEL and a <strong>Product Certification Body (OCP)</strong> accredited by INMETRO.',
  'about.p2': 'Gaudi Enterprises offers global <strong>type approval</strong>, <strong>homologation</strong> and <strong>regulatory compliance</strong> services to manufacturers, test laboratories, and third-party agencies across the world. We are also the commercial agent for Mexico NOM OCP via SEATSA and Brazil OCD Anatel and Inmetro via Bracert Certificaçãos.',
  'about.p3': 'Our team of regulatory experts brings more than 20 years of experience in international certification of communication products — across consumer electronics, household appliances, enterprise terminals, industrial logistics, automotive, IoT and marine.',
  'about.points.0': 'Consulting and proposals on GMA strategy pre-approvals',
  'about.points.1': 'Efficient, smooth project execution during approvals',
  'about.points.2': 'Certificate validity tracking and renewal alerts',
  'about.points.3': 'Monitoring global regulatory updates and product impact',
  'about.points.4': 'Investigating acceptability of emerging technologies',
  'about.imgAlt': 'Certification documentation workspace',
  'about.imgTitle': 'GaudiEnt certification services',

  // Certification
  'cert.eyebrow': 'Why choose us',
  'cert.title': 'Who is Gaudi Enterprises',
  'cert.intro': 'We are a Designated Certification Body (OCD) authorized by ANATEL and also a Product Certification Body (OCP) accredited by INMETRO. Our role is to assess whether your product and your company meet current regulations, and to issue a Certificate of Technical Conformity once your product complies with all standards and requirements established by regulatory agencies.',
  'cert.heading': 'The two pillars of product certification in Brazil',
  'cert.pillar.0.role': 'Designated Certification Body (OCD)',
  'cert.pillar.0.points.0': 'Authorized by ANATEL to assess telecommunications products under mandatory certification.',
  'cert.pillar.0.points.1': 'Issues the Certificate of Technical Conformity.',
  'cert.pillar.1.role': 'Product Certification Body (OCP)',
  'cert.pillar.1.points.0': 'Accredited by INMETRO to certify products in accordance with technical standards.',
  'cert.pillar.1.points.1': 'Provides product certification based on quality, safety and performance.',

  // Services
  'services.eyebrow': 'What we do',
  'services.title': 'Comprehensive Compliance Services',
  'services.0.title': 'Type Approval and Homologation',
  'services.0.desc': 'End-to-end management of national type approvals and homologation for radio, telecom and EMC products in 180+ markets.',
  'services.1.title': 'Product Certification and Regulatory Consulting',
  'services.1.desc': 'GMA strategy pre-approval proposals, gap analysis and certification roadmaps tailored to your launch plan.',
  'services.2.title': 'Certificate Maintenance',
  'services.2.desc': 'Validity tracking, renewal reminders and change notifications so certificates never lapse.',
  'services.3.title': 'Regulatory Monitoring',
  'services.3.desc': 'Continuous watch on global regulation updates with impact assessments for your portfolio.',
  'services.4.title': 'Local Representation',
  'services.4.desc': 'In-country representative and importer-of-record services where authorities require a local entity.',
  'services.5.title': 'Emerging Tech Research',
  'services.5.desc': 'Worldwide acceptability studies for UWB, Wi-Fi 7, satellite IoT, V2X and other new technologies.',

  // Categories
  'categories.eyebrow': 'Industries',
  'categories.title': 'Service Categories',
  'categories.imgTitle': '{{name}} certification',
  'categories.0.name': 'Consumer Electronics',
  'categories.0.count': '1,240 projects',
  'categories.1.name': 'Household Appliances',
  'categories.1.count': '860 projects',
  'categories.2.name': 'Automotive & V2X',
  'categories.2.count': '410 projects',
  'categories.3.name': 'Industrial & IoT',
  'categories.3.count': '720 projects',
  'categories.4.name': 'Enterprise Terminals',
  'categories.4.count': '530 projects',
  'categories.5.name': 'Marine & Satellite',
  'categories.5.count': '180 projects',

  // Onboarding
  'onboarding.eyebrow': 'How it works',
  'onboarding.title': 'Client Onboarding in 4 Steps',
  'onboarding.0.title': 'Discovery Call',
  'onboarding.0.desc': 'Share your product specs, target markets and launch timeline with a dedicated regulatory expert.',
  'onboarding.1.title': 'Compliance Roadmap',
  'onboarding.1.desc': 'Receive a country-by-country plan with requirements, lead times and transparent quotation.',
  'onboarding.2.title': 'Documentation & Testing',
  'onboarding.2.desc': 'We prepare dossiers, coordinate local testing and liaise with certification bodies on your behalf.',
  'onboarding.3.title': 'Approval & Aftercare',
  'onboarding.3.desc': 'Certificates delivered to your dashboard with ongoing renewal tracking and regulatory alerts.',
  'onboarding.cta': 'Begin Your Onboarding',

  // CTA + footer
  'cta.imgAlt': 'Global partnerships background',
  'cta.title': 'Trusted by regulators, labs and partners worldwide',
  'cta.text': 'We keep your certification process trackable and your business ahead of every regulatory movement.',
  'cta.link': 'See the full list of supported countries',
  'footer.title': 'Contact for Support',
  'contact.0.label': 'WhatsApp',
  'contact.1.label': 'Mobile',
  'contact.2.label': 'Email',
  'contact.3.label': 'WeChat',
  'footer.address': 'Registered Address',
  'footer.directions': 'Get Directions',
  'footer.phone': 'Tel / WhatsApp',
  'footer.copy': '© 2026 GaudiEnt Global Compliance. All rights reserved.',
  'footer.tagline': 'Type Approval · Homologation · Regulatory Compliance · Certification',
};
export default home;
